import React from 'react'

import { InvoicesTable } from 'Features/accountSettings/components/Billing/InvoicesTable/InvoicesTable'
import { useTranslation } from 'react-i18next'
import { InvoicesTableModalStyled } from './InvoicesModal.styled'
import { ModalControlsStyled, Modal, Button } from '@clickcease/cc-client-components-lib'

interface InvoicesTableModalProps {
  isOpen?: boolean
  onOpenChange: (a: boolean) => void
}

export const InvoicesTableModal = ({ isOpen, onOpenChange }: InvoicesTableModalProps) => {
  const { t } = useTranslation('accountSettings')

  return (
    <Modal
      id={'invoices-modal'}
      title={t('invoices_modal.title')}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onCloseClick={() => {}}
    >
      <InvoicesTableModalStyled>
        <InvoicesTable numOfRows={'all'} />
        <ModalControlsStyled>
          <Button
            className="ok-button"
            text={t('invoices_modal.ok')}
            onClick={() => onOpenChange(false)}
          />
        </ModalControlsStyled>
      </InvoicesTableModalStyled>
    </Modal>
  )
}
